/**
 * Typography Tokens
 *
 * Font families, sizes, and line heights extracted from the design system.
 */

export const typographyTokens = {
  // Font Families
  fontFamilies: {
    sans: 'DM Sans, system-ui, sans-serif', // Matches pounce fonts.primary
    serif: '"Blender Pro", serif',
    mono: '"Roboto Mono", SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', // Matches pounce fonts.mono
  },

  // Font Sizes (in rem)
  fontSizes: {
    xxs: '0.625rem', // 10px
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.375rem', // 22px
    '2xl': '1.5rem', // 24px
    '3xl': '1.625rem', // 26px
    '4xl': '1.75rem', // 28px
    '5xl': '1.875rem', // 30px
    '6xl': '2rem', // 32px
    '7xl': '2.25rem', // 36px
    '8xl': '2.5rem', // 40px
    '9xl': '3.75rem', // 60px
  },

  // Line Heights (in rem)
  lineHeights: {
    xxs: '0.75rem', // 12px
    xs: '0.875rem', // 14px
    sm: '1.125rem', // 18px
    base: '1.5rem', // 24px
    lg: '1.5rem', // 24px
    xl: '1.75rem', // 28px
    '2xl': '1.75rem', // 28px
    '3xl': '1.75rem', // 28px
    '4xl': '2rem', // 32px
    '5xl': '2.125rem', // 34px
    '6xl': '2.25rem', // 36px
    '7xl': '2.5rem', // 40px
    '8xl': '3rem', // 48px
    '9xl': '4.5rem', // 72px
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  letterSpacings: {
    normal: 'normal',
    relaxed: '1.5px',
  },
} as const;

export type TypographyTokens = typeof typographyTokens;
